import { requiredMessage, pleaseChoose, pleaseEnterTheMessage } from "../utils/common";
var defaultFieldName = "sex";
var iapFieldName = "student's sex";
var VARIANTS = {
  ARHI: defaultFieldName,
  IAP: iapFieldName
};
var VARIANT_REQUIRED_FUNCTION = {
  ARHI: pleaseChoose,
  IWHI: requiredMessage,
  IAP: pleaseEnterTheMessage
};
var validSex = function validSex(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var error; // eslint-disable-line init-declarations
  var derivedFieldName = fieldName || VARIANTS[funnel] || VARIANTS.ARHI;
  if (!value) {
    var requiredFunction = VARIANT_REQUIRED_FUNCTION[funnel] || VARIANT_REQUIRED_FUNCTION.ARHI;
    error = requiredFunction(derivedFieldName);
  }
  return error;
};
export default validSex;